import { Injectable } from '@angular/core';
import {Session} from '../../shared/models/session';
import {BehaviorSubject, firstValueFrom, Subject} from 'rxjs';
import {AngularFireAuth} from '@angular/fire/auth';
import firebase from 'firebase/app';
import 'firebase/auth';
import {Router} from '@angular/router';
import {AngularFirestore} from '@angular/fire/firestore';
import GoogleAuthProvider = firebase.auth.GoogleAuthProvider;
import {Account} from '../../shared/models/account';
import {Message} from '../../shared/models/message';
import {MessageService} from './message.service';
import {LocalStorageService} from './local-storage.service';
import {KeyString} from '../../shared/typeAliases';

@Injectable({
  providedIn: 'root'
})
export class SessionService {
  public session = new Session();
  public sessionSubject = new Subject<Session>(); // 追加
  public sessionBehaviorSubject = new BehaviorSubject<Session>(this.session);
  public sessionState = this.sessionSubject.asObservable(); // 追加

  constructor(private db: AngularFirestore,
              private afAuth: AngularFireAuth,
              private router: Router,
              private messageService: MessageService,
              private localStorageService: LocalStorageService) {
    this.afAuth.idToken.subscribe(token => {
      this.session.token = token ?? '';
      this.sessionSubject.next(this.session);
    });
    this.afAuth.idTokenResult.subscribe(idTokenResult2 => {
      if (idTokenResult2) {
        const claims = idTokenResult2.claims;
        for (const key in claims) {
          if (key === 'customerId') {
            if (!claims[key]) {
              console.log(key, 'is false');
              this.afAuth.signOut().then(() => {
                location.reload();
              });
            }
          }
          if (claims.hasOwnProperty(key)) {
            // eslint-disable-next-line
            (this.session as KeyString<any>)[key] = !!claims[key];
            if (!!claims[key]) {
              console.log(key, 'is true');
            }
          }
        }
      }
    });
    this.afAuth.onAuthStateChanged(user => {
      if (user) {
        this.session.login = true;
        this.session.user = user;
        this.sessionSubject.next(this.session);
        this.db.collection('users').doc(this.session.user.email).valueChanges()
          .subscribe((personalSetting: any) => {
            this.session.personalSetting = personalSetting;
            this.sessionBehaviorSubject.next(this.session);
            console.log('authed: constructor');
          });
      }
    });
  }

  /**
   *
   */
  next(): void {
    this.sessionSubject.next(this.session);
    this.sessionBehaviorSubject.next(this.session);
  }

  /**
   *
   */
  loginWithEmailAndPassword(password: Account): void {
    this.session.loading = true;
    this.afAuth.setPersistence(firebase.auth.Auth.Persistence.LOCAL)
      .then(() => {
        this.afAuth
          .signInWithEmailAndPassword(password.email, password.password)
          .then(this.loginCallback)
          .catch(this.errorCallback);
      });
  }

  /**
   *
   */
  login(): void {
    this.session.loading = true;
    // 変更
    // @ts-ignore
    this.afAuth.setPersistence(firebase.auth.Auth.Persistence.LOCAL)
      .then(() => {
        const provider = new GoogleAuthProvider();
        this.afAuth
          .signInWithPopup(provider)
          .then(this.loginCallback)
          .catch(this.errorCallback);
      });
  }

  loginCallback = (auth: any) => {
    if (!auth.user.emailVerified) {
      this.afAuth.signOut().then(() => {
        location.reload();
      });
    }
    firstValueFrom(this.afAuth.idToken).then((token: any) => {
      this.session.token = token;
    });
    this.session.login = true;
    this.session.user = auth.user;
    this.sessionSubject.next(this.session);
    this.sessionBehaviorSubject.next(this.session);
    this.session.loading = false;
    // await this.appInitService.Init();
    return this.router.navigate(['/']);
  };

  errorCallback = (err: any) => {
    let message = 'ログインに失敗しました。';
    if (err.code === 'auth/user-not-found') {
      message = '権限がありません。';
    } else if (err.code === 'auth/wrong-password') {
      message = 'パスワードが正しくありません。';
    }
    this.messageService.pushError(message);
  };

  doAuth = async() => {
    return new Promise((resolve2) => {
      this.afAuth.onAuthStateChanged(user => {
        if (!user) { return resolve2(user);}
        this.session.login = true;
        this.session.user = user;
        this.sessionSubject.next(this.session);
        this.db.collection('users').doc(this.session.user.email).valueChanges()
          .subscribe((personalSetting: any) => {
            this.session.personalSetting = personalSetting;
            this.sessionBehaviorSubject.next(this.session);
            console.log('authed: doAuth');
            resolve2(user);
          });
      });
    });
  };

  // doLogin = async () => {
  //   // @ts-ignore
  //   return this.afAuth.setPersistence(firebase.auth.Auth.Persistence.LOCAL)
  //     .then(() => {
  //       const provider = new GoogleAuthProvider();
  //       return this.afAuth
  //         .signInWithPopup(provider);
  //     })
  //     .then(auth => {
  //       if (!auth.user?.emailVerified) {
  //         this.afAuth.signOut().then(() => {
  //           location.reload();
  //         });
  //       }
  //       // this.afAuth.idToken.toPromise().then((token: string) => {
  //       //   this.session.token = token;
  //       // });
  //       this.session.login = true;
  //       this.session.user = auth.user.email;
  //       // this.session.domain = auth.user.email.split('@')[1];
  //       this.sessionSubject.next(this.session);
  //       this.session.loading = false;
  //       return this.router.navigate(['/']);
  //     })
  //     .catch(err => {
  //       console.log(err);
  //       // const message = new Message();
  //       // message.type = 'error';
  //       // message.message = 'ログインに失敗しました';
  //       // this.messageService.messageSubject.next(message);
  //       // this.session.loading = false;
  //     });
  // };

  /**
   *
   */
  logout(): void {
    this.session.loading = true;
    const email = this.session.personalSetting.mail;
    this.afAuth
      .signOut()
      .then(() => {
        this.session.reset();
        this.sessionSubject.next(this.session);
        console.log('logout', email);
        return this.router.navigate(['/auth/login']);
      })
      .then(() => {
        this.localStorageService.clear();
        this.session.loading = false;
        // RouteReuseStrategyで保持しているcomponentを初期化するため再読み込み
        // と言うよりは各サービスで保持されているデータを初期化するため。
        // RouteReuseStrategyで保持しているcomponentを初期化するだけならrefreshAll()でいけるはず。
        location.reload();
      })
      .catch(err => {
        this.session.loading = false;
        console.log(err);
      });
  }

  /**
   *
   */
  sendPasswordResetEmail(passwordResetEmail: string): void {
    firebase.auth().sendPasswordResetEmail(passwordResetEmail)
      .then(() => {
        const message = new Message();
        message.type = 'info';
        message.message = 'パスワード再設定メールを送信しました。';
        this.messageService.messageSubject.next(message);
      })
      .catch(err => {
        console.log(err);
      });
  }
}
